import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function forgotPasswordFailure(draft: Draft<IAuthData>) {
  draft.forgotPassword.config.isLoading = false;
  draft.forgotPassword.config.email = '';
}

export default forgotPasswordFailure;
